module.exports = __webpack_public_path__ + "static/img/pay_icon1.2eb76403.png";